import { Component, ElementRef, OnInit} from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { OtListModel } from '../models/ot-listModel';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { IPDService } from '../Services/ipdServices.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ExportService } from 'app/reports/services/export.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OptoModel } from 'app/EMR/PrimaryExaminationModels/opto.model';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-ot-list',
  templateUrl: './ot-list.component.html',
  styleUrls: ['./ot-list.component.scss'],
})
export class otListComponent implements OnInit {
  destroyotlist$: Subject<boolean> = new Subject<boolean>();
  private otlistModel: OtListModel = {}
  private getOTGroupArray: any = [];
  private getOTtheatreArray: any = [];
  private gedataArray: any = [];
  private getadrArray: any = [];
  FkRegIdvalue: any;
  searchType: string = 'PatientId';
  showSpinner: boolean = false
  searchParaValue: string = '';
  private getOprationArray: any = [];
  private getOTListPostponedArray: any = [];
  selectedPatientId: string | null = null;
  pageSize = 100;
  currentPage = 0;
  totalData: any[] = [];
  isLoadingMore = false;
  autoOTControl: FormControl; 
  autoOTTControl:FormControl;
  autoOTSControl:FormControl;
  autoSeControl:FormControl;
  autoOPControl:FormControl;
  private getOTListArray: any = [];

  constructor(private authService: AuthService,
    private ipdService: IPDService,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService,
    private dialog: MatDialog,
    private exportdata: ExportService,
    private datePipe: DatePipe,
    private emrservice: EMRService
  ) {
    this.GetStausData();
  }
  ngOnInit() {
    this.GetotData();
    this.GetOtTheatreData();
    this.getDoctor();
    this.GetOPrationType();
    // this.setDefaultStatus();
    this.otlistModel.StatusName = 'Booked'
    this.otlistModel.BranchName = this.authService.Loggeduser.branchname;
    this.otlistModel.FK_BranchId = this.authService.Loggeduser.branchid;
    this.otlistModel.SurgeryToDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.otlistModel.SurgeryFromDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.showadvRecord(2)
    this.autoOTControl = new FormControl();
    this.autoOTTControl = new FormControl();
    this.autoOTSControl = new FormControl();
    this.autoSeControl = new FormControl();
    this.autoOPControl = new FormControl();
  }
  selectedIndex: number | null = null;
  selectPatient(item: any, index: number) {
    // this.otlistModel.Surgonid = item.fK_MainSurgeronId;
    this.selectedPatientId = item.patientId;
    this.selectedIndex = index;
  }

  getbranchobj(e) {
    const selectedbranch = this.authService.Branches.find(
      (loc) => loc.branchName == e.value
    );
    if (selectedbranch) {
      this.otlistModel.FK_BranchId = selectedbranch.pkBranchId;
      this.otlistModel.BranchName = selectedbranch.branchName;
    }
  }

  GetotData() {
    this.getOTGroupArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService.GetOTData(BranchId).pipe(takeUntil(this.destroyotlist$)).subscribe((item) => {
        this.getOTGroupArray = item.filter((x) => x.isActive == true);
        this.initializeLabDeliveryControl();
      },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } catch (e) { }
  }

  onScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight && !this.isLoadingMore) {
      this.loadMoreData();
    }
  }
  
  loadMoreData() {
    this.isLoadingMore = true;
    this.currentPage++;
  
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
  
    const moreData = this.totalData.slice(start, end);
    this.getOTListArray = [...this.getOTListArray, ...moreData];
  
    this.isLoadingMore = false;
  }

  GetOtTheatreData() {
    this.getOTtheatreArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService
        .GetOtTheatre(BranchId)
        .pipe(takeUntil(this.destroyotlist$))
        .subscribe(
          (item) => {
            this.getOTtheatreArray = item.filter((x) => x.isActive == true);
            this.initializeOTTControl();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }

  getDoctor() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroyotlist$)).subscribe((res) => {
      this.getadrArray = res;
      this.initializeSControl();
    })
  }

  getSurgobj(e) {
      this.otlistModel.SurgonName = e.value;
      this.otlistModel.Surgonid = e.id;
  }

  clearSurgonName(Sid){
    if (!Sid) {
      this.otlistModel.Surgonid = null;
    }
  }
  GetOPrationType() {
    this.ipdService.GetOPType().pipe(takeUntil(this.destroyotlist$)).subscribe((res) => {
      this.getOprationArray = res
      this.initializeOPControl();
    })
  }

  getOptypeobj(e) {
      this.otlistModel.operationTypeName = e.value;
      this.otlistModel.pK_OperationTypeId = e.id;
  }
  clearOP(OPid){
    if (!OPid) {
      this.otlistModel.pK_OperationTypeId = null;
    }
  }

  getOTgroupbj(e) {
    this.otlistModel.OTGroup = e.value;
    this.otlistModel.OTgroupId = e.id;
  }

  clearOTName(OTid: any) {
    if (!OTid) {
      this.otlistModel.OTgroupId = null;
    }
  }
  GetStausData() {
    this.ipdService.GetStauscheck().pipe(takeUntil(this.destroyotlist$)).subscribe((res: any) => {
      this.gedataArray = []
      this.gedataArray = res.filter((x) => x.isActive == true);
      this.initializeOTSControl();
    })
  }
  getOTListPostponed() {
   var fromdate = moment(this.otlistModel.SurgeryFromDate).format('YYYY-MM-DD')
    this.ipdService.GetOTListPostponed(this.otlistModel.FK_BranchId,fromdate, 0).pipe((takeUntil(this.destroyotlist$))).subscribe((res: any) => {
      this.getOTListPostponedArray = res;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getStatusobj(e) {
      this.otlistModel.StatusName = e.value;
      this.otlistModel.pK_SurgeryStatusId = e.id;
  }

  clearOTS(OTSid){
    if (!OTSid) {
      this.otlistModel.pK_SurgeryStatusId = null;
    }
  }

  // setDefaultStatus() {
  //   debugger;
  //   const defaultStatus = this.gedataArray.find(status => status.surgeryStatus == "Booked");
  //   if (defaultStatus) {
  //     this.otlistModel.StatusName = defaultStatus.surgeryStatus;
  //     this.otlistModel.pK_SurgeryStatusId = defaultStatus.pK_SurgeryStatusId;
  //   }
  // }

  getTheatreNameObj(e) {
    this.otlistModel.TheatreName = e.value;
      this.otlistModel.pK_OTTheatreId = e.id;
  }

  clearOTT(tid: any) {
    if (!tid) {
      this.otlistModel.pK_OTTheatreId = null;
    }
  }

  filteregetOTGroupArray:Observable<any[]>
   initializeLabDeliveryControl() {
      this.autoOTControl = new FormControl(this.otlistModel.OTGroup || '');
  
      this.filteregetOTGroupArray = this.autoOTControl.valueChanges.pipe(
        startWith(this.otlistModel.OTGroup || ''),
        map((status) =>
          status
            ? this.filterLabDeliveryFunction(status)
            : this.getOTGroupArray.slice()
        )
      );
    }

    filterLabDeliveryFunction(name: string): any[] {
      return this.getOTGroupArray.filter((group) =>
        group.groupName.toLowerCase().includes(name.toLowerCase())
      );
    }


    filteregetOTTGroupArray:Observable<any[]>
   initializeOTTControl() {
      this.autoOTTControl = new FormControl(this.otlistModel.TheatreName || '');
  
      this.filteregetOTTGroupArray = this.autoOTTControl.valueChanges.pipe(
        startWith(this.otlistModel.TheatreName || ''),
        map((status) =>
          status
            ? this.filterOTTFunction(status)
            : this.getOTtheatreArray.slice()
        )
      );
    }

    filterOTTFunction(name: string): any[] {
      return this.getOTtheatreArray.filter((theatre) =>
        theatre.theatreName.toLowerCase().includes(name.toLowerCase())
      );
    }

    filteregetOTSGroupArray:Observable<any[]>
    initializeOTSControl() {
       this.autoOTSControl = new FormControl(this.otlistModel.StatusName || '');
   
       this.filteregetOTSGroupArray = this.autoOTSControl.valueChanges.pipe(
         startWith(this.otlistModel.StatusName || ''),
         map((status) =>
           status
             ? this.filterOTSFunction(status)
             : this.gedataArray.slice()
         )
       );
     }
 
     filterOTSFunction(name: string): any[] {
       return this.gedataArray.filter((status) =>
        status.surgeryStatus.toLowerCase().includes(name.toLowerCase())
       );
     }

     filteregetSGroupArray:Observable<any[]>
     initializeSControl() {
        this.autoSeControl = new FormControl(this.otlistModel.SurgonName || '');
    
        this.filteregetSGroupArray = this.autoSeControl.valueChanges.pipe(
          startWith(this.otlistModel.SurgonName || ''),
          map((status) =>
            status
              ? this.filterSFunction(status)
              : this.getadrArray.slice()
          )
        );
      }
  
      filterSFunction(name: string): any[] {
        return this.getadrArray.filter((user) =>
         user.userName.toLowerCase().includes(name.toLowerCase())
        );
      }


      filteregetOPGroupArray:Observable<any[]>
      initializeOPControl() {
         this.autoOPControl = new FormControl(this.otlistModel.operationTypeName || '');
     
         this.filteregetOPGroupArray = this.autoOPControl.valueChanges.pipe(
           startWith(this.otlistModel.operationTypeName || ''),
           map((status) =>
             status
               ? this.filterOPFunction(status)
               : this.getOprationArray.slice()
           )
         );
       }
   
       filterOPFunction(name:any): any[] {
         return this.getOprationArray.filter((Optype) =>
          Optype.operationTypeName.toLowerCase().includes(name.toLowerCase())
         );
       }
 
  onSearchTypeChange(event: any) {
    this.searchType = event.value;
  }

  helpListPOpup(parameter) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: parameter
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyotlist$)).subscribe(result => {
      if (result != 0) {
        this.otlistModel.caseType = result;
      }
    });
  }

  printOTlist() {
    const content = document.getElementById('content');
    const rows = content?.querySelectorAll('tr');
    if (!rows || rows.length === 0) return;
  
    // how many cols in each chunk
    const FIRST_COUNT  = 10;
    const SECOND_COUNT = 10;
    const THIRD_COUNT  = 9;
  
    let head1 = '', head2 = '', head3 = '';
    let body1 = '', body2 = '', body3 = '';
  
    rows.forEach((row: HTMLTableRowElement, idx: number) => {
      const cells = Array.from(row.children) as HTMLElement[];
  
      const cols1 = cells.slice(0, FIRST_COUNT).map(c => c.outerHTML).join('');
      const cols2 = cells.slice(FIRST_COUNT, FIRST_COUNT + SECOND_COUNT)
                         .map(c => c.outerHTML).join('');
      const cols3 = cells.slice(FIRST_COUNT + SECOND_COUNT, FIRST_COUNT + SECOND_COUNT + THIRD_COUNT)
                         .map(c => c.outerHTML).join('');
  
      if (idx === 0) {
        head1 = `<thead><tr>${cols1}</tr></thead>`;
        head2 = `<thead><tr>${cols2}</tr></thead>`;
        head3 = `<thead><tr>${cols3}</tr></thead>`;
      } else {
        body1 += `<tr>${cols1}</tr>`;
        body2 += `<tr>${cols2}</tr>`;
        body3 += `<tr>${cols3}</tr>`;
      }
    });
  
    const styles = `
    <style>
      table.print-table {
          width: 100%;
         
        }
      /* Adjust page margins if you need more real estate */
      @page {
        size: auto;
        margin: 0.5in; 
      }
    
      @media print {
        /* 1) Make each table cover 100% of the printable area */
        table.print-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;       /* let browser size columns naturally */
          margin-bottom: 16px;
        }
    
        /* 2) Cell borders, padding, wrapping */
        table.print-table th,
        table.print-table td {
          border: 1px solid #333;
          padding: 4px 6px;
          white-space: normal;      /* wrap long text */
          overflow: visible;
          text-overflow: clip;
          font-size: 10px;          /* shrink font for print if needed */
        }
    
        /* 3) Header row style */
        table.print-table thead th {
          background: #007bff;
          color: #fff;
          -webkit-print-color-adjust: exact;
        }
    
        /* 4) Force each table on its own page */
        .page-break {
          page-break-before: always;
        }
      }
    </style>
    `;
    
    
  
    const headerHtml = this.printType === 2
      ? `<h2>Surgery Booking List From ${moment(this.otlistModel.SurgeryFromDate).format('DD-MM-YYYY')} To ${moment(this.otlistModel.SurgeryToDate).format('DD-MM-YYYY')}</h2>`
      : `<h2>Surgery Booking List</h2>`;
  
    const tableChunk = (head: string, body: string) => `
      <table class="print-table">
        ${head}
        <tbody>${body}</tbody>
      </table>
    `;
  
    const html = `
      <html>
        <head>
          <title>OT List</title>
          ${styles}
        </head>
        <body>
          ${headerHtml}
          ${tableChunk(head1, body1)}
          <div class="page-break"></div>
          ${headerHtml}
          ${tableChunk(head2, body2)}
          <div class="page-break"></div>
          ${headerHtml}
          ${tableChunk(head3, body3)}
          <script>
            setTimeout(() => { window.print(); }, 200);
          </script>
        </body>
      </html>
    `;
  
    const win = window.open('', '_blank');
    win?.document.write(html);
  }
  
  
  
  

  
  totalPatients: number = 0;
  printType: number = 1;
  showadvRecord(type) {
    this.printType = type;
    let payload: any
    if (!this.otlistModel.StatusName) {
      this.dashboardService.openSnackBar("Please Select Status", "OK");
      return;
    }
    this.showSpinner = true;
    if (type == 2) {
      payload = {
        "FK_BranchId": this.otlistModel.FK_BranchId,
        "FromSurgeryDate": moment(this.otlistModel.SurgeryFromDate).format('YYYY-MM-DD'),
        "ToSurgeryDate": moment(this.otlistModel.SurgeryToDate).format('YYYY-MM-DD'),
        "OTGroup": this.otlistModel.OTGroup ? this.otlistModel.OTGroup : null,
        "OT": this.otlistModel.TheatreName ? this.otlistModel.TheatreName : null,
        "Status": this.otlistModel.StatusName,
        "Surgon": this.otlistModel.SurgonName ? this.otlistModel.SurgonName : null,
        "CaseType": this.otlistModel.caseType ? this.otlistModel.caseType : null,
        // "FkRegId": null,
        // "Searchtype":"S",
        // "SearchPara":this.searchType ? this.searchType : null,
        // "SearchParaValue":this.searchParaValue ? this.searchParaValue : null
      }
    } else if (type == 1) {
      payload = {
        "FK_BranchId": this.otlistModel.FK_BranchId,
        "FromSurgeryDate": moment(this.otlistModel.SurgeryFromDate).format('YYYY-MM-DD'),
        "ToSurgeryDate": moment(this.otlistModel.SurgeryToDate).format('YYYY-MM-DD'),
        "OTGroup": this.otlistModel.OTGroup ? this.otlistModel.OTGroup : null,
        "OT": this.otlistModel.TheatreName ? this.otlistModel.TheatreName : null,
        "Status": this.otlistModel.StatusName,
        "Surgon": this.otlistModel.SurgonName ? this.otlistModel.SurgonName : null,
        "CaseType": this.otlistModel.caseType ? this.otlistModel.caseType : null,
        "Searchtype": "S",
        "SearchPara": this.searchType,
        "SearchParaValue": this.searchParaValue
      }
    }

    this.ipdService.GetOTList(payload).pipe(takeUntil(this.destroyotlist$)).subscribe((res: any) => {
      this.getOTListArray = [];
      if (res.length > 0) {
        this.totalData = res;
        // this.getOTListArray = res;
        this.getOTListArray = this.totalData.slice(0, this.pageSize);
        this.currentPage = 0;
        this.totalPatients = res.length;
        this.showSpinner = false;

      } else {
        this.dashboardService.openSnackBar("No Record Found", "OK");
        this.selectedPatientId = null
      }
      this.showSpinner = false;
    },err =>{
      this.showSpinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
    // this.closeAdvanceSearchFilter();
    document.getElementById("advanceSearchFilter").style.display = "none";
  }

  // formatTime(time: string | null | undefined): string {
  //   return moment(time, "HH:mm a").format("hh:mm A");
  // }

  formatTime(time: string | null | undefined): string {
    return moment(time, ["hh:mm A", "HH:mm"]).format("HH:mm");
  }
  
  advanceSearchFilter() {
    document.getElementById("advanceSearchFilter").style.display = "block";
  }
  closeAdvanceSearchFilter() {
    this.otlistModel.OTGroup = null;
    this.otlistModel.TheatreName = null;
    this.otlistModel.SurgonName = null;
    this.otlistModel.caseType = null;
    this.otlistModel.operationTypeName = null;
  
  
    this.autoOTControl.reset();
    this.autoOTTControl.reset();
    this.autoSeControl.reset();
    this.autoOPControl.reset();
  
    document.getElementById("advanceSearchFilter").style.display = "none";
  }
  rescheduleSurgeryModalOpen() {
    document.getElementById("rescheduleSurgeryModal").style.display = "block";
    this.getOTListPostponed()

  }

  closerescheduleSurgeryModal() {
    this.otlistModel.Surgonid = 0;
    document.getElementById("rescheduleSurgeryModal").style.display = "none";
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'OT List');
  }

  timecheck: any;
  convert24Time12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != "") {
      let hour = this.timecheck.split(":")[0];
      let min = this.timecheck.split(":")[1];
      let part = hour > 12 ? "PM" : "AM";

      min = (min + "").length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length == 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    } else {
      return null;
    }
  }

  getsummary_url(patientid: number) {
    if (patientid) {
      let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Medical Record' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.dashboardService.getsummary_url().pipe(takeUntil(this.destroyotlist$)).subscribe(
          data => this.succesurl(data, patientid), err => this.failedurl(err)
        )
      } else {
        this.showSpinner = true;
        this.printTimelineBill(patientid);
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  succesurl(data, patientid) {

    const urldate = data.filter(item => item.propertyName == 'WebURL');
    const url = urldate[0].propertyValue;

    var newWindow = window.open(url + 'PatientEMRSummary.aspx?RegID=' + patientid + '&BillCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&VisitOrderType=DESC' + '&BranchId=' + this.authService.Loggeduser.branchid);

  }

  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  printTimelineBill(regid) {
    let payload = {
      "WebReportPrintMaster": {
        "module": "Doctor",
        // "printOption": "Prescription",
        "printOption": "Medical Record",
        "printType": "WebNetramReport",
        "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
        "PrintTime": this.dashboardService.convertTime12Hour(new Date()),
        "Pk_RegId": regid,
        "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
        "PRINTCONFIGURATIONARRAY": 'N',
        "Pk_VisitId": 0,
        "Pk_ExamId": 0,
        "VISITDATE": this.datePipe.transform(new Date(), "dd-MM-yyyy"),
        "LINE1": this.dashboardService.branchmansterObj.line1,
        "LINE2": this.dashboardService.branchmansterObj.line2,
        "LINE3": this.dashboardService.branchmansterObj.line3,
        "LINE4": this.dashboardService.branchmansterObj.line4,
        "HOSPITALIMAGE": "../../../" + this.authService.loginclientlogo,
        "COMPANYIMAGE": "../../../" + this.authService.leftbottomlogosm,
        "CERTIFICATE1IMAGE": "../../../" + this.authService.nabhlogo,
        "CERTIFICATE2COMPANYIMAGE": '',
        "PrintHeaderArray": 'Y',
        "PatientRegistrationArray": 'Y',
        "VisitMasterArray": 'Y',
        'HistoryGeneralArray': 'Y',
        'DoctorExaminationMasterArray': 'Y',
        'AutoRefExaminationArray': 'Y',
        'HistoryDiseaseArray': 'Y',
        "CounselorExaminationArray": 'Y',
        "HistorySurgicalArray": 'Y',
        "HistoryFamilyArray": 'Y',
        "HistoryDrugAllergyArray": 'Y',
        "PresentingComplaintsArray": 'Y',
        "AdvisedInvestigationsArray": 'Y',
        "IntraocularPressureArray": 'Y',
        "OptoExaminationArray": 'Y',
        "OptoTestDetailArray": 'Y',
        "OptoSlitLampExaminationArray": 'Y',
        "CurrentMedicationDetailArray": 'Y',
        "DoctorFindingArray": 'Y',
        "DoctorInvestigationArray": 'Y',
        "DoctorDiagnosisArray": 'Y',
        "DoctorPrescriptionArray": 'Y',
        "DoctorSurgeryArray": 'Y',
      }
    }
    this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
      this.showSpinner = false;
      if (x.length > 0) {
        let printContents, popupWin;
        printContents = x[0].printTemplate;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`
        );

        popupWin.document.close();
      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    }, err => {
      this.showSpinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  ngOnDestroy() {
    this.destroyotlist$.next(true);
    this.destroyotlist$.unsubscribe();
    this.getOTListArray = null;
    this.gedataArray = null;
    this.getOprationArray = null;
    this.getOTGroupArray = null;
    this.getOTtheatreArray = null;
    this.gedataArray = null;
    this.getadrArray = null;
    this.getOTListPostponedArray = null;
    this.filteregetOPGroupArray = null;
    this.filteregetSGroupArray = null;
    this.filteregetOTSGroupArray = null;
    this.filteregetOTTGroupArray = null;
    this.filteregetOTGroupArray = null
  }

}
